import { createClient } from '@supabase/supabase-js';

// Readdy Backend 連線設定 (由環境變數注入；anon key 為公開可曝露之用量金鑰)。
// 整個應用僅建立一個 client 實例 (singleton)。
const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);